<template>
  <div class="c-black">
    <v-row>
      <v-col cols="4">
        <b-street-view-photo :match="match" @streetview="streetView"></b-street-view-photo>
      </v-col>

      <v-col class="pl-4" cols="8" v-if="match">
        <v-row class="mb-2 justify-space-between">
          <div class="mxw-90pc">
            <div class="mb-2" v-if="match.availability_coverage">
              <v-chip class="" x-small color="primary" label outlined>
                OPEN SPOTS
              </v-chip>
            </div>
            <div @click="$emit('details', match)" class="c-black fw-500 fs-22 pointer" v-text="match.name"></div>
          </div>
          <b-favorite :match_id="match.id" class="mr-2"></b-favorite>
        </v-row>

        <v-row @click="$emit('details', match)" class="mb-2">
          <div class="pointer fs-16 fw-500">{{ match.address1 }}, {{ match.city }}, {{ match.zip }}</div>
        </v-row>

        <v-row @click="$emit('details', match)" class="mb-2" v-if="match.hours_description">
          <div class="fs-16 fw-500 pointer">
            <span v-text="match.hours_description"></span>
            <v-icon class="c-dark-blue fs-18 ml-1 v-align-bottom" v-if="match.hours_coverage">check_circle</v-icon>
          </div>
        </v-row>

        <v-row @click="$emit('details', match)" class="mb-2" v-if="match.ages_description">
          <div class="fs-16 fw-500 pointer">
            <span v-text="match.ages_description"></span>
            <v-icon class="c-dark-blue fs-18 ml-1 v-align-bottom" v-if="match.ages_coverage">check_circle</v-icon>
          </div>
        </v-row>

        <v-row class="mb-0">
          <b-parent-rating :match="match" class="mr-4"></b-parent-rating>
          <b-state-rating :match="match"></b-state-rating>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="px-3 pt-1">
      <v-col class="ta-center">
        <a class="td-none" :href="match.website" target="_blank">
          <v-icon class="fs-16 va-sub" color="primary">public</v-icon>
          <span class="fs-14 fw-500 ml-1">Website</span>
        </a>
      </v-col>

      <v-col class="ta-center">
        <a class="td-none" :href="'tel:' + match.phone">
          <v-icon class="c-black fs-16 va-sub" color="primary">phone</v-icon>
          <span class="fs-14 fw-500 ml-1">{{ match.phone || 'No phone' }}</span>
        </a>
      </v-col>

      <v-col class="ta-center">
        <a class="td-none" :href="match.data.license.url" target="_blank">
          <v-icon class="c-black fs-16 va-sub" color="primary">info</v-icon>
          <span class="fs-14 fw-500 ml-1">#{{ match.state_provider_id }}</span>
        </a>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Api from '../../services/bright_finder.js'
import Favorite from './favorite.vue'
import ParentRating from './parent_rating.vue'
import StateRating from './state_rating.vue'
import StreetViewPhoto from './street_view_photo.vue'

export default {
  components: {
    'b-favorite': Favorite,
    'b-parent-rating': ParentRating,
    'b-state-rating': StateRating,
    'b-street-view-photo': StreetViewPhoto,
  },

  computed: {
    inquiry_pending: function() {
      return this.search.inquiries[this.match.id] || this.availability_requested
    },

    position: function() {
      return { lat: this.match.latitude, lng: this.match.longitude }
    },

    website: function() {
      if(this.match.google_place) {
        return this.match.google_place.website
      }
      return null;
    },

    website_preview: function() {
      var preview = this.website
      if(preview.indexOf("http") == 0) {
        preview = preview.split("//")[1].split("/")[0]
      }
      if(preview > 45) {
        preview = preview.substring(0,45) + "..."
      }
      return preview
    },
  },

  data: function() {
    return {
      availability_requested: false,
    }
  },

  methods: {
    requestAvailability: function() {
      var vm = this
      Api.bright_finder.inquiry.create(vm.search.bf_api_token, vm.match.id, function(resp) {
        vm.search.inquiries = resp.data
        vm.availability_requested = true
        vm.$store.commit('showAlert', 'Availability update request submitted.')
      })
    },

    streetView: function(location) {
      this.$emit('streetview', location)
    }
  },

  props: ['match', 'search'],
}
</script>
